import { adminCall, adminGet } from './adminCall';

export function toUserDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'object' && value.seconds != null) {
    const date = new Date(Number(value.seconds) * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export async function adminListAppUsers(params = {}) {
  const qs = new URLSearchParams();
  if (params.role) qs.set('role', params.role);
  if (params.accountType) qs.set('accountType', params.accountType);
  if (params.createdAfter) qs.set('createdAfter', params.createdAfter);
  if (params.uncleared) qs.set('uncleared', 'true');
  if (params.search) qs.set('search', params.search);
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.offset != null) qs.set('offset', String(params.offset));
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const result = await adminGet(`/api/admin/app-users${suffix}`);
  return {
    users: result.users || [],
    total: result.total || 0,
  };
}

export async function adminGetAppUser(userId) {
  const result = await adminGet(`/api/admin/app-users/${encodeURIComponent(userId)}`);
  return result.user || null;
}

export async function adminUpdateAppUser(userId, payload) {
  const result = await adminCall(`/api/admin/app-users/${encodeURIComponent(userId)}`, payload || {});
  return result.user || null;
}

export async function adminGetCompanyByUserId(userId) {
  return adminGet(`/api/admin/app-users/${encodeURIComponent(userId)}/company`);
}

export async function adminAddAppUserComment(userId, text) {
  const result = await adminCall(`/api/admin/app-users/${encodeURIComponent(userId)}/comments`, { text });
  return result.user || null;
}

export async function adminUpdateAppUserComment(userId, commentId, text) {
  const result = await adminCall(
    `/api/admin/app-users/${encodeURIComponent(userId)}/comments/${encodeURIComponent(commentId)}`,
    { text }
  );
  return result.user || null;
}

export async function adminDeleteAppUserComment(userId, commentId) {
  const result = await adminCall(
    `/api/admin/app-users/${encodeURIComponent(userId)}/comments/${encodeURIComponent(commentId)}/delete`
  );
  return result.user || null;
}

export async function adminGetCompanyAppointmentStats(companyId, { year, month }) {
  const qs = new URLSearchParams({
    year: String(year),
    month: String(month),
  });
  return adminGet(`/api/admin/companies/${encodeURIComponent(companyId)}/appointment-stats?${qs.toString()}`);
}
